import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoanMatchProtector = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "loanMatchProtector",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13132",
			fill: "none",
			d: "M3,3h24v24H3V3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13135",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M12.6,25.9H6.5c-1.3,0-2.4-1.1-2.4-2.4v-17c0-1.3,1.1-2.4,2.4-2.4h14.6c1.3,0,2.4,1.1,2.4,2.4v4.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13136",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M15,17.5l4.9-2.5l4.9,2.5v3.6c0,2.7-2.2,4.9-4.9,4.9S15,23.8,15,21.1V17.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13137",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M8.9,9.2v11.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13138",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M13.8,13.4V14"
		})
	]
});
export default SvgLoanMatchProtector;
